import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../common/store'
const login = () => import('../components/common/frame/login.vue')
const home = () => import('../components/common/frame/Home.vue')
// 帮助
const reportHelp = () => import('../components/common/help/index.vue')

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
const routerList = []
function importALL(item) {
    item.keys().forEach(ele => routerList.push(item(ele).default))
}
importALL(require.context('.', false, /\.router\.js/))
// console.log(...routerList)
const router = new VueRouter({
    base: __dirname,
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            component: login
        },
        {
            path: '/help',
            component: reportHelp
        },
        {
            path: '/survey',
            component: home,
            children: [...routerList]
        },
        {
            path: '/error',
            component: home,
            children: [
                {
                    path: '403',
                    name: '403',
                    component: () => import('@/components/error/403.vue')
                }
            ]
        }
    ],
    // 回滚到指定的位置
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    // console.log(process.env.NODE_ENV)
    let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/
    let objExp = new RegExp(Expression)
    let path = to.path.substr(0, 1) === '/' ? to.path.substr(1) : to.path
    // 清除导航筛选条件
    store.commit({
        type: 'setQueryCommon',
        data: {}
    })
    store.commit({
        type: 'setQueryData',
        data: {}
    })
    store.commit({
        type: 'setQueryTable',
        data: {}
    })
    store.commit({
        type: 'setDialog',
        data: false
    })
    store.commit({
        type: 'setTopSlide',
        data: true
    })
    if (objExp.test(path)) {
        window.open(path)
    } else {
        if (to.matched.some(r => r.meta.requireAuth)) {
            // let empId = sessionStorage.getItem('emp_id')
            // if (empId) {
            //   next()
            // } else {
            //   next({
            //     path: '/client/login',
            //     query: {
            //       redirect: to.fullPath
            //     }
            //   })
            // }
        } else {
            next()
        }
    }
})
export default router
